module.exports = __webpack_public_path__ + "img/Pic_Sy_Lb_10.23f173e7.png";